import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useHistory } from "react-router-dom";

import { setThemeMode } from '../actions/navBar.action';
import { Switch } from '@material-ui/core';
import {yellow, blueGrey} from '@material-ui/core/colors';
import NightsStayIcon from '@material-ui/icons/NightsStay';
import Brightness7Icon from '@material-ui/icons/Brightness7';

const ThemeLightning = (props) => {
  const history = useHistory();
  let verify = history.location.pathname.split('/')[2]==='cash';
  const [modeDark, setModeDark] = useState(false);
  const [showMode, setShowMode] = useState(verify);

  const handleModeChange = event => {
    setModeDark(event.target.checked);
    event.target.checked?props.setThemeMode('dark'):props.setThemeMode('light');
  };
  useEffect(() => {
    return history.listen((location) => { 
      if (location.pathname.split('/')[2]==='cash'){
        setShowMode(true);
      } else setShowMode(false);
      // console.log(`You changed the page to: ${location.pathname}`); 
    }); 
  }, [history]);

  return (
    <>
      {showMode&&<Switch
        checked={modeDark}
        onChange={handleModeChange}
        name="themeMode"
        color='primary'
        icon={<Brightness7Icon style={{color:yellow['600'], fontSize:'1.65rem' }} />}
        checkedIcon={<NightsStayIcon style={{color:blueGrey['600'], fontSize:'1.65rem' }} />}
      />}
    </>
  );
};

const mapStateToProps = (state) => ({
//   themeMode:state.navBarReducer.themeMode
});

const mapDispatchToProps = (dispatch) => {
  return {
    setThemeMode: (payload) => dispatch(setThemeMode(payload)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ThemeLightning);
